<layout-sidebar>
  <div class="main">
    <div class="row">
      <div class="column twelve">
        <h2 class="heading-main">Frequently Asked Questions</h2>
        <ds-accordion [allowMultipleOpenCategories]="true" [allowToggleAccordion]="true">
          <ds-accordion-category [title]="'1'">
            <div class="accordion-content-wrapper">
              <p dsContent [contentPath]="'billing.faq'"></p>
              <hr aria-hidden="true" class="dashed" />
              <div>Content</div>
            </div>
          </ds-accordion-category>
          <ds-accordion-category [title]="'2'">
            <div class="accordion-content-wrapper">
              <p dsContent [contentPath]="'billing.faq'"></p>
              <hr aria-hidden="true" class="dashed" />
              <div>Content</div>
            </div>
          </ds-accordion-category>
          <ds-accordion-category [title]="'3'">
            <div class="accordion-content-wrapper">
              <p dsContent [contentPath]="'billing.faq'"></p>
              <hr aria-hidden="true" class="dashed" />
              <div>Content</div>
            </div>
          </ds-accordion-category>
          <ds-accordion-category [title]="'4'">
            <div class="accordion-content-wrapper">
              <p dsContent [contentPath]="'billing.faq'"></p>
              <hr aria-hidden="true" class="dashed" />
              <div>Content</div>
            </div>
          </ds-accordion-category>
          <ds-accordion-category [title]="'5'">
            <div class="accordion-content-wrapper">
              <p dsContent [contentPath]="'billing.faq'"></p>
              <hr aria-hidden="true" class="dashed" />
              <div>Content</div>
            </div>
          </ds-accordion-category>
        </ds-accordion>
      </div>
    </div>
  </div>

  <aside class="main-aside">
    <div class="row">
      <nav class="sub column twelve md-six lg-twelve">
        <h4>Quick Links</h4>
        <ul>
          <li><a href="#">Make a Payment</a></li>
          <li><a href="#">Proof of Insurance</a></li>
          <li><a href="#">My Documents</a></li>
          <li><a href="#">Contact Us</a></li>
          <li><a href="#">FAQ</a></li>
        </ul>
      </nav>
      <div class="column twelve md-six lg-twelve"><agents-list></agents-list></div>
    </div>
  </aside>
</layout-sidebar>
